module.exports = __webpack_public_path__ + "static/media/Dipankar Sahu.5f2545bc.png";